export default __webpack_public_path__ + "static/media/respiration.030868ed.svg";